import { Component, OnInit } from '@angular/core';
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'app-app-admin-sidebar',
  templateUrl: './app-admin-sidebar.component.html',
  styles: []
})
export class AppAdminSidebarComponent implements OnInit {

  public isAdmin: boolean = false;
  public isSuperAdminOrAdmin: boolean = false;
  public isSuperAdmin: boolean;

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.checkSuperAdmin();
    this.checkSuperAdminOrAdmin();
  }

  public checkSuperAdmin(){
    return this.authService.isSuperAdmin();
  }

  public checkSuperAdminOrAdmin(){
    return this.authService.isSuperAdminOrAdmin();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-admin-sidebar/app-admin-sidebar.component.ts